module.exports = __webpack_public_path__ + "static/media/repair.1464053c.svg";